/* eslint-disable */ import { memoEval, sceneEntityObjectPropertiesComponent, sceneEntityRemoteObjectComponent } from '@salsita-ai/platform-project-sdk/domain';
import { attachComponent } from '../implementation.js';
export const lynxSinkBaseComponents = [
    attachComponent.withComponent(sceneEntityRemoteObjectComponent, 'body', true).withEntity('LynxSinkBase').attach(memoEval(()=>[], ()=>({
            fileUrl: '/models/jms.glb',
            objectName: 'CABINET_LYNX-SBLXH-24L_BODY',
            dimensionUnit: 'inch'
        }))),
    attachComponent.withComponent(sceneEntityObjectPropertiesComponent, 'body', true).withEntity('LynxSinkBase').attach(memoEval((self)=>[
            self.$width
        ], ($width)=>({
            morphTargetInfluences: {
                Width: {
                    value: $width,
                    scaleZero: 24 * 25.4,
                    scaleOne: 30 * 25.4
                }
            }
        })))
];

//# sourceMappingURL=lynx-sink-base.js.map